import { apiClient } from '@/lib/api/client'

export interface DeviceHealthSummary {
  online: number
  idle: number
  offline: number
  total: number
  [key: string]: unknown
}

export const DeviceHealthService = {
  async getSummary(): Promise<DeviceHealthSummary> {
    const response = await apiClient.get('/system-settings/device-health/summary')
    return response.data ?? {}
  },
}
